import { SHIPMENT_STATUS } from '@fielded/fs-api/lib/shipment/constants'

export const dosageForms = [
  'Ampoule',
  'Bottle',
  'Caplet',
  'Capsule',
  'Cup',
  'Cream',
  'Device',
  'Diskus',
  'Drops',
  'IUD',
  'Implant',
  'Infusion',
  'Inhaler',
  'Injection',
  'Liquid',
  'Lotion',
  'Pack',
  'Pessary',
  'Pill',
  'Pouch',
  'Sachet',
  'Softgel',
  'Spray',
  'Suppository',
  'Suspension',
  'Syrup',
  'Tablet',
  'Test kit',
  'Tube',
  'Vial'
]

// Type of the list in the Product Browsing view. Affects filters/type of list items/sorting options
export const PRODUCT_BROWSER_LIST_TYPE = {
  ORDER_SL: 'orderSL',
  ORDER_FS: 'orderFS',
  SUBSCRIPTION_SL: 'subscriptionSL'
}

export const ORDER_DISPLAY_STATUS = {
  IN_REVIEW: 'in-review',
  PROCESSING: 'processing',
  IN_TRANSIT: 'in-transit',
  RECEIVED: 'received',
  CANCELLED: 'cancelled'
}

export const ORDER_STATUS_LABELS = {
  [ORDER_DISPLAY_STATUS.IN_REVIEW]: 'In review',
  [ORDER_DISPLAY_STATUS.PROCESSING]: 'Processing',
  [ORDER_DISPLAY_STATUS.IN_TRANSIT]: 'In transit',
  [ORDER_DISPLAY_STATUS.RECEIVED]: 'Received',
  [ORDER_DISPLAY_STATUS.CANCELLED]: 'Cancelled'
}

export const SHIPMENT_STATUS_TO_ORDER_DISPLAY_STATUS = {
  [SHIPMENT_STATUS.NEW]: ORDER_DISPLAY_STATUS.PROCESSING,
  [SHIPMENT_STATUS.PACKED]: ORDER_DISPLAY_STATUS.PROCESSING,
  [SHIPMENT_STATUS.SENT]: ORDER_DISPLAY_STATUS.IN_TRANSIT,
  [SHIPMENT_STATUS.ARRIVED]: ORDER_DISPLAY_STATUS.IN_TRANSIT,
  [SHIPMENT_STATUS.RECEIVED]: ORDER_DISPLAY_STATUS.RECEIVED
}
